import { useMemo } from 'react';
import { UserType } from 'api/models';
import { PartnerPermissionName } from 'api/partner/types';
import { useAllCompanies } from 'queries/account';
import { AccountFeature, useAccountFeature } from './use-account-feature';
import { useUserSafe } from './use-user';
export const useIsRestrictedPartnerUser = ()=>{
    var _profile_user, _profile_user_company, _profile_user1;
    const profile = useUserSafe();
    const userType = profile === null || profile === void 0 ? void 0 : (_profile_user = profile.user) === null || _profile_user === void 0 ? void 0 : _profile_user.userType;
    const currentUserCompanyId = profile === null || profile === void 0 ? void 0 : (_profile_user1 = profile.user) === null || _profile_user1 === void 0 ? void 0 : (_profile_user_company = _profile_user1.company) === null || _profile_user_company === void 0 ? void 0 : _profile_user_company.companyId;
    const { data: partnerCompanies } = useAllCompanies();
    return useMemo(()=>{
        var _find_accessLevel, _find;
        if (!profile) {
            return false;
        }
        return userType === UserType.Partner && ((_find = (partnerCompanies !== null && partnerCompanies !== void 0 ? partnerCompanies : []).find(({ companyId })=>companyId === currentUserCompanyId)) === null || _find === void 0 ? void 0 : (_find_accessLevel = _find.accessLevel) === null || _find_accessLevel === void 0 ? void 0 : _find_accessLevel.partnerPermissionSetName) === PartnerPermissionName.Restricted;
    }, [
        currentUserCompanyId,
        partnerCompanies,
        profile,
        userType
    ]);
};
export const usePartnerCompanyPermission = ()=>{
    var _profile_user, _profile_company;
    const [isTimesheetFeatureEnabled] = useAccountFeature(AccountFeature.Timesheets);
    const profile = useUserSafe();
    const userType = profile === null || profile === void 0 ? void 0 : (_profile_user = profile.user) === null || _profile_user === void 0 ? void 0 : _profile_user.userType;
    const canTrackTime = profile === null || profile === void 0 ? void 0 : (_profile_company = profile.company) === null || _profile_company === void 0 ? void 0 : _profile_company.canTrackTime;
    return useMemo(()=>{
        var _ref;
        return {
            canPartnerTrackTime: (_ref = isTimesheetFeatureEnabled && userType === UserType.Partner && canTrackTime) !== null && _ref !== void 0 ? _ref : false
        };
    }, [
        canTrackTime,
        isTimesheetFeatureEnabled,
        userType
    ]);
};
export const isPartnerUser = ({ userType })=>{
    return userType === UserType.Partner;
};
export const useIsCurrentUserPartner = ()=>{
    const profile = useUserSafe();
    const user = profile === null || profile === void 0 ? void 0 : profile.user;
    return useMemo(()=>user ? isPartnerUser(user) : false, [
        user
    ]);
};
export const useDoesPartnerMatchPermissionName = (partnerPermissionName)=>{
    var _profile_user, _profile_user_company, _profile_user1;
    const profile = useUserSafe();
    const userType = profile === null || profile === void 0 ? void 0 : (_profile_user = profile.user) === null || _profile_user === void 0 ? void 0 : _profile_user.userType;
    const currentUserCompanyId = profile === null || profile === void 0 ? void 0 : (_profile_user1 = profile.user) === null || _profile_user1 === void 0 ? void 0 : (_profile_user_company = _profile_user1.company) === null || _profile_user_company === void 0 ? void 0 : _profile_user_company.companyId;
    const { data: partnerCompanies } = useAllCompanies();
    return useMemo(()=>{
        var _find_accessLevel, _find;
        if (!profile) {
            return false;
        }
        return userType === UserType.Partner && ((_find = (partnerCompanies !== null && partnerCompanies !== void 0 ? partnerCompanies : []).find(({ companyId })=>companyId === currentUserCompanyId)) === null || _find === void 0 ? void 0 : (_find_accessLevel = _find.accessLevel) === null || _find_accessLevel === void 0 ? void 0 : _find_accessLevel.partnerPermissionSetName) === partnerPermissionName;
    }, [
        currentUserCompanyId,
        partnerCompanies,
        partnerPermissionName,
        profile,
        userType
    ]);
};
